/**
 * SidebarCard — the standard glass-surface card used by sidebar panel
 * sections (Mannequin, Material, Curve properties, Edit-mode summary,
 * Reference, Generator, Modifier rows, Inspector cards, etc.).
 *
 * Wraps `GLASS_PANEL` from `styles.ts` with the canonical 10×14 padding so
 * every sidebar card draws from one source. Forwards standard div props so
 * callers can attach pointer/click handlers; pass `style` to override or
 * extend (callers commonly add `overflow: "hidden"`).
 *
 * Distinct from `panelSurface.tsx`, which renders the chrome of a *floating*
 * draggable panel.
 */

import type { HTMLAttributes } from "react";
import { GLASS_PANEL } from "./styles.ts";

export type SidebarCardProps = HTMLAttributes<HTMLDivElement>;

export function SidebarCard({ children, style, ...rest }: SidebarCardProps) {
  return (
    <div style={{ ...GLASS_PANEL, padding: "10px 14px", ...style }} {...rest}>
      {children}
    </div>
  );
}
